<template>
<div class="reservations-table-collapse-body clearfix">
  <slot name="title">
    <div class="-row" v-bind:style="rowStyle">
      <div
          v-for="t in ticks"
          class="-cell"
          v-bind:style="cellStyleByTick(t)"
          @mouseover="$dispatch('tick-over', t)"
          @mouseout="$dispatch('tick-out', t)"
      ></div>
    </div>
  </slot>
  <slot v-if="!isCollapsed"></slot>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'reservations-table-collapse-body',
  mixins: [require('../body.vue')],
  props: {
    isCollapsed: {
      type: Boolean,
      twoWay: true,
      default: true,
    },
  },
}
</script>



// WEBPACK FOOTER //
// body.vue?7168f74a